import {createSelector} from 'reselect';
import {isInApp} from '../utils/user-agent';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings, isInApp],
  (settings, inApp) => {
    if (inApp) {
      return !settings?.force_show_email_for_guest_in_app;
    }
    
    return !settings?.force_show_email_for_guest;
  },
);
